import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";
import TextReveal from "./TextReveal";

const CHAPTERS = [
  {
    n: "01",
    title: "In-house legal, not just consultants",
    body:
      "Our team includes practicing advocates specializing in MSMED Act arbitration and industrial-policy litigation. We don't outsource the hard part — we argue it.",
  },
  {
    n: "02",
    title: "On-ground Haryana industrial-policy expertise",
    body:
      "Make in Haryana, PADMA, Atmanirbhar Textile Policy — we have filed, defended, and disbursed under each of them. We know the desks, the deadlines, and the deltas.",
  },
  {
    n: "03",
    title: "End-to-end, paperwork to disbursement",
    body:
      "Eligibility assessment, DPR preparation, application filing, department follow-ups, sanction, and money-in-the-bank. One accountable partner, one line of sight.",
  },
  {
    n: "04",
    title: "DPIIT-recognized, government-facing credibility",
    body:
      "As a startup recognized by the Government of India's DPIIT, we operate with the same institutional posture and paper-trail rigour that departments expect.",
  },
];

export const WhyUs = () => (
  <section
    id="why"
    data-testid={TID.why.root}
    className="relative bg-paper-2 py-24 md:py-32 overflow-hidden"
  >
    <div aria-hidden className="absolute top-0 left-1/3 h-[440px] w-[440px] rounded-full bg-[color:var(--violet)]/12 blur-[150px]" />
    <div aria-hidden className="absolute bottom-10 right-10 h-[360px] w-[360px] rounded-full bg-[color:var(--gold)]/12 blur-[120px]" />

    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-12 gap-6 pb-14 md:pb-20 border-b border-navy/10">
        <div className="col-span-12 md:col-span-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-navy/60">
            06 — Manifesto · Why MSMEmoney
          </p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <TextReveal as="h2" className="font-serif tracking-tight text-4xl md:text-6xl leading-[1.02] text-navy">
            Advisors write reports. We move money.
          </TextReveal>
        </div>
      </div>

      <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-y-16 md:gap-y-24 md:gap-x-16">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ delay: (i % 2) * 0.1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="relative grid grid-cols-12 gap-6"
          >
            <div className="col-span-4 md:col-span-3">
              <span
                className="font-serif italic text-[110px] md:text-[160px] leading-none tracking-tighter block"
                style={{ color: "rgba(6,19,41,0.10)" }}
                aria-hidden
              >
                {c.n}
              </span>
            </div>
            <div className="col-span-8 md:col-span-9 pt-4 md:pt-8">
              <h3 className="font-serif text-2xl md:text-3xl text-navy tracking-tight leading-tight">
                <TextReveal>{c.title}</TextReveal>
              </h3>
              <p className="mt-4 text-navy/70 text-[15px] leading-relaxed max-w-md">
                <TextReveal>{c.body}</TextReveal>
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
